/** Runtime configuration injected via /config.js (same image for every environment). */
export interface RuntimeConfig {
  apiBaseUrl: string;
  appVersion: string;
  defaultLocale: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<RuntimeConfig>;
  }
}

export const runtimeConfig: RuntimeConfig = {
  apiBaseUrl: '/api',
  appVersion: 'dev',
  defaultLocale: 'en',
  ...(typeof window !== 'undefined' ? window.__APP_CONFIG__ : {}),
};
